module.exports = __webpack_public_path__ + "assets/img/dx20.68508fa0.jpg";